<div class="widget">
  <ng-container *ngIf="cycleId; else unknown">
    <ng-container *ngIf="entry.product.status === ProductStatus.approved">
      <div class="col-md-3">
        <div class="votebutton" id="deniedButton" *minPrivilege="'FULL'" [class.selected]="markedForNoInvite" (click)="markForNotInvite()">
          <markant-tooltip for="deniedButton" label="Für Absage vormerken" placement="bottom" trigger="mouseenter" color-scheme="dark"> </markant-tooltip>
          <mat-icon [class.selected]="markedForNoInvite">close</mat-icon>
        </div>
      </div>

      <div class="col-md-6">
        <ng-container *ngTemplateOutlet="thumbs"></ng-container>
      </div>
      <div class="col-md-3">
        <div
          class="votebutton invited"
          id="invitedButton"
          *minPrivilege="'FULL'"
          [class.selected]="markedForInvite"
          (click)="markForInvite()"
          matTooltip="Für Einladung vormerken"
        >
          <markant-tooltip for="invitedButton" label="Für Einladung vormerken" placement="bottom" trigger="mouseenter" color-scheme="dark"> </markant-tooltip>
          <mat-icon>mail</mat-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="entry.product.status === ProductStatus.invited">
      <div class="statusText invited">eingeladen!</div>
    </ng-container>

    <ng-container *ngIf="entry.product.status === ProductStatus.notInvited">
      <div class="statusText notInvited">abgesagt</div>
    </ng-container>
  </ng-container>
  <ng-template #unknown>
    <div class="unknown"></div>
  </ng-template>
</div>

<ng-template #thumbs>
  <div class="thumbs" id="thumbs" *minPrivilege="'FULL'">
    <markant-tooltip for="thumbs" label="Anzahl an abgegebenen positiven Stimmen" placement="bottom" trigger="mouseenter" color-scheme="dark">
    </markant-tooltip>
    <ng-container *ngIf="voteCount as vc">
      <mat-icon>thumb_up</mat-icon>
      {{ vc | option }}
    </ng-container>
  </div>
</ng-template>
